import { render } from "./main.vue?vue&type=template&id=44b86ecc"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"
script.render = render

export default script